var endpointMap = {
	cs: {
		"pages.homepage": "translation-cs.json"
	},
	"cs-CZ": {
		"pages.homepage": "translation-cs.json"
	},
	da: {
		"pages.homepage": "translation-da.json"
	},
	"da-DK": {
		"pages.homepage": "translation-da.json"
	},
	de: {
		"pages.homepage": "translation-de.json"
	},
	"de-DE": {
		"pages.homepage": "translation-de.json"
	},
	el: {
		"pages.homepage": "translation-el.json"
	},
	"el-GR": {
		"pages.homepage": "translation-el.json"
	},
	en: {
		"pages.homepage": "translation-en.json"
	},
	"en-AU": {
		"pages.homepage": "translation-en.json"
	},
	"en-CA": {
		"pages.homepage": "translation-en.json"
	},
	"en-GB": {
		"pages.homepage": "translation-en.json"
	},
	"en-IN": {
		"pages.homepage": "translation-en.json"
	},
	"en-US": {
		"pages.homepage": "translation-en.json"
	},
	es: {
		"pages.homepage": "translation-es.json"
	},
	"es-ES": {
		"pages.homepage": "translation-es.json"
	},
	"es-MX": {
		"pages.homepage": "translation-es.json"
	},
	"es-US": {
		"pages.homepage": "translation-es.json"
	},
	fi: {
		"pages.homepage": "translation-fi.json"
	},
	"fi-FI": {
		"pages.homepage": "translation-fi.json"
	},
	fr: {
		"pages.homepage": "translation-fr.json"
	},
	"fr-CA": {
		"pages.homepage": "translation-fr.json"
	},
	"fr-FR": {
		"pages.homepage": "translation-fr.json"
	},
	hi: {
		"pages.homepage": "translation-hi.json"
	},
	"hi-IN": {
		"pages.homepage": "translation-hi.json"
	},
	hr: {
		"pages.homepage": "translation-hr.json"
	},
	"hr-HR": {
		"pages.homepage": "translation-hr.json"
	},
	hu: {
		"pages.homepage": "translation-hu.json"
	},
	"hu-HU": {
		"pages.homepage": "translation-hu.json"
	},
	it: {
		"pages.homepage": "translation-it.json"
	},
	"it-IT": {
		"pages.homepage": "translation-it.json"
	},
	ja: {
		"pages.homepage": "translation-ja.json"
	},
	"ja-JP": {
		"pages.homepage": "translation-ja.json"
	},
	lt: {
		"pages.homepage": "translation-lt.json"
	},
	"lt-LT": {
		"pages.homepage": "translation-lt.json"
	},
	lv: {
		"pages.homepage": "translation-lv.json"
	},
	"lv-LV": {
		"pages.homepage": "translation-lv.json"
	},
	nb: {
		"pages.homepage": "translation-nb.json"
	},
	"nb-NO": {
		"pages.homepage": "translation-nb.json"
	},
	nl: {
		"pages.homepage": "translation-nl.json"
	},
	"nl-NL": {
		"pages.homepage": "translation-nl.json"
	},
	pl: {
		"pages.homepage": "translation-pl.json"
	},
	"pl-PL": {
		"pages.homepage": "translation-pl.json"
	},
	pt: {
		"pages.homepage": "translation-pt.json"
	},
	"pt-BR": {
		"pages.homepage": "translation-pt.json"
	},
	"pt-PT": {
		"pages.homepage": "translation-pt.json"
	},
	ro: {
		"pages.homepage": "translation-ro.json"
	},
	"ro-RO": {
		"pages.homepage": "translation-ro.json"
	},
	sk: {
		"pages.homepage": "translation-sk.json"
	},
	"sk-SK": {
		"pages.homepage": "translation-sk.json"
	},
	sl: {
		"pages.homepage": "translation-sl.json"
	},
	"sl-SI": {
		"pages.homepage": "translation-sl.json"
	},
	sv: {
		"pages.homepage": "translation-sv.json"
	},
	"sv-SE": {
		"pages.homepage": "translation-sv.json"
	},
	tr: {
		"pages.homepage": "translation-tr.json"
	},
	"tr-TR": {
		"pages.homepage": "translation-tr.json"
	},
	und: {
		"pages.homepage": "translation.json"
	},
	zh: {
		"pages.homepage": "translation-zh.json"
	},
	"zh-HK": {
		"pages.homepage": "translation-zh.json"
	},
	"zh-TW": {
		"pages.homepage": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
